(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["consultation-form"] && !Shopify.designMode) return;
  try {
    
  class ConsultationFormTracker {
    constructor() {
      this.formId = 'ConsultationForm-{{ section.id }}';
      this.successId = 'consultation-form-success-{{ section.id }}';
      this.init();
    }

    init() {
      // URL parametresini kontrol et ve başarı mesajını göster
      this.checkSuccessMessage();

      const form = document.getElementById(this.formId);
      if (!form) return;

      // UTM parametrelerini yakala ve form alanlarına ekle
      this.captureUTMParameters();

      // Form gönderimini dinle
      form.addEventListener('submit', (e) => {
        this.trackSubmission();
      });
    }

    checkSuccessMessage() {
      const urlParams = new URLSearchParams(window.location.search);
      const contactPosted = urlParams.get('contact_posted');
      
      if (contactPosted === 'true') {
        // Başarı mesajını bul ve scroll yap
        const successMessage = document.getElementById(this.successId);
        if (successMessage) {
          // Mesaj varsa scroll yap
          setTimeout(() => {
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
            successMessage.focus();
          }, 100);
        }

        // Hash varsa scroll yap (form ID'sine)
        if (window.location.hash) {
          setTimeout(() => {
            const targetElement = document.querySelector(window.location.hash);
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 200);
        }
      }
    }

    captureUTMParameters() {
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {
        source: urlParams.get('utm_source') || '',
        medium: urlParams.get('utm_medium') || '',
        campaign: urlParams.get('utm_campaign') || '',
        term: urlParams.get('utm_term') || '',
        content: urlParams.get('utm_content') || ''
      };

      // Session storage'dan da kontrol et (sayfa yenilendiğinde kaybolmaması için)
      if (!utmParams.source && sessionStorage.getItem('utm_source')) {
        utmParams.source = sessionStorage.getItem('utm_source');
        utmParams.medium = sessionStorage.getItem('utm_medium') || '';
        utmParams.campaign = sessionStorage.getItem('utm_campaign') || '';
        utmParams.term = sessionStorage.getItem('utm_term') || '';
        utmParams.content = sessionStorage.getItem('utm_content') || '';
      } else if (utmParams.source) {
        // Yeni UTM parametreleri varsa session storage'a kaydet
        sessionStorage.setItem('utm_source', utmParams.source);
        if (utmParams.medium) sessionStorage.setItem('utm_medium', utmParams.medium);
        if (utmParams.campaign) sessionStorage.setItem('utm_campaign', utmParams.campaign);
        if (utmParams.term) sessionStorage.setItem('utm_term', utmParams.term);
        if (utmParams.content) sessionStorage.setItem('utm_content', utmParams.content);
      }

      // Form alanlarına değerleri ata
      const sourceField = document.getElementById('utm_source');
      const mediumField = document.getElementById('utm_medium');
      const campaignField = document.getElementById('utm_campaign');
      const termField = document.getElementById('utm_term');
      const contentField = document.getElementById('utm_content');

      if (sourceField) sourceField.value = utmParams.source;
      if (mediumField) mediumField.value = utmParams.medium;
      if (campaignField) campaignField.value = utmParams.campaign;
      if (termField) termField.value = utmParams.term;
      if (contentField) contentField.value = utmParams.content;
    }

    trackSubmission() {
      // Google Analytics veya diğer tracking sistemleri için event gönder
      if (typeof gtag !== 'undefined') {
        gtag('event', 'form_submit', {
          'event_category': 'Consultation Form',
          'event_label': 'Consultation Form Submission',
          'value': 1
        });
      }

      // Facebook Pixel tracking
      if (typeof fbq !== 'undefined') {
        fbq('track', 'Lead');
      }

      // Custom event dispatch
      window.dispatchEvent(new CustomEvent('consultationFormSubmit', {
        detail: {
          formId: this.formId,
          timestamp: new Date().toISOString()
        }
      }));
    }
  }

  // Sayfa yüklendiğinde başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ConsultationFormTracker();
    });
  } else {
    new ConsultationFormTracker();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inas-collection"] && !Shopify.designMode) return;
  try {
    
  class InasCollectionScroller {
    constructor(root) {
      this.root = root;
      this.scroller = root.querySelector('.inas-collection__scroller');
      this.prev = root.querySelector('.inas-collection__arrow--prev');
      this.next = root.querySelector('.inas-collection__arrow--next');
      this.scrollHint = root.querySelector('[data-scroll-hint]');

      if (!this.scroller) return;

      const visible = Number(
        this.scroller.dataset.visibleItemsDesktop || 6
      );

      const scrollStep = () => {
        const item = this.scroller.querySelector('.inas-collection__item');
        if (!item) return this.scroller.clientWidth;
        const style = window.getComputedStyle(item);
        const width = item.getBoundingClientRect().width;
        const gap = parseFloat(style.marginRight) || 0;
        return (width + gap) * visible;
      };

      const handleClick = (direction) => {
        const step = scrollStep();
        if (!step) return;
        const delta = direction === 'next' ? step : -step;
        this.scroller.scrollBy({ left: delta, behavior: 'smooth' });
      };

      // Center content if it's smaller than container
      const centerContent = () => {
        const wrapper = this.scroller.parentElement;
        if (!wrapper) return;

        const scrollerWidth = this.scroller.scrollWidth;
        const wrapperWidth = wrapper.clientWidth;

        if (scrollerWidth < wrapperWidth) {
          const padding = (wrapperWidth - scrollerWidth) / 2;
          this.scroller.style.paddingInlineStart = `${padding}px`;
          this.scroller.style.paddingInlineEnd = `${padding}px`;
        } else {
          this.scroller.style.paddingInlineStart = '';
          this.scroller.style.paddingInlineEnd = '';
        }
      };

      const updateScrollHintVisibility = () => {
        if (!this.scrollHint) return;
        const isAtEnd = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 2;
        const hasOverflow = this.scroller.scrollWidth > this.scroller.clientWidth;
        if (hasOverflow && isAtEnd) {
          this.scrollHint.classList.add('is-scrolled-end');
        } else {
          this.scrollHint.classList.remove('is-scrolled-end');
        }
      };

      // Center on load and resize
      centerContent();
      window.addEventListener('resize', () => {
        centerContent();
        updateScrollHintVisibility();
      });
      if (this.scrollHint) {
        this.scroller.addEventListener('scroll', updateScrollHintVisibility);
        updateScrollHintVisibility();
      }

      if (this.prev) {
        this.prev.addEventListener('click', () => handleClick('prev'));
      }
      if (this.next) {
        this.next.addEventListener('click', () => handleClick('next'));
      }
    }
  }

  document
    .querySelectorAll('.inas-collection')
    .forEach((root) => new InasCollectionScroller(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatay-link-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_MARGIN = '240px 0px';

    function upgradeImage(img) {
      if (!img || img.dataset.mhLgLoaded === '1') return;
      img.dataset.mhLgLoaded = '1';

      var srcset = img.getAttribute('data-srcset');
      var sizes = img.getAttribute('data-sizes');
      var src = img.getAttribute('data-src');

      if (srcset) img.setAttribute('srcset', srcset);
      if (sizes) img.setAttribute('sizes', sizes);
      if (src) img.setAttribute('src', src);

      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
      img.removeAttribute('data-src');

      var reveal = function () {
        img.classList.remove('mh-lg__image--pending');
        img.classList.add('mh-lg__image--loaded');
      };

      if (typeof img.decode === 'function') {
        img.decode().then(reveal).catch(reveal);
      } else if (img.complete) {
        reveal();
      } else {
        img.addEventListener('load', reveal, { once: true });
        img.addEventListener('error', reveal, { once: true });
      }
    }

    function initRoot(root) {
      if (!root || root.dataset.mhLgInit === '1') return;
      root.dataset.mhLgInit = '1';

      var imgs = root.querySelectorAll('img.mh-lg__image[data-srcset]');
      if (!imgs.length) return;

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < imgs.length; i++) upgradeImage(imgs[i]);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (!entry.isIntersecting) continue;
            upgradeImage(entry.target);
            io.unobserve(entry.target);
          }
        },
        { rootMargin: ROOT_MARGIN, threshold: 0.01 }
      );

      for (var j = 0; j < imgs.length; j++) io.observe(imgs[j]);
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-mh-lg]');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
